import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_item_hdr_RowInterface, bl_fi_mst_item_hdr_RowClass, bl_fi_mst_item_ext_RowClass, bl_fi_mst_label_hdr_RowClass, bl_fi_mst_label_link_RowClass } from '../../dbschema/index';

export class SettlementMethodContainerModel extends BaseContainerModel {
  bl_fi_mst_item_hdr: bl_fi_mst_item_hdr_RowInterface = new bl_fi_mst_item_hdr_RowClass();
  bl_fi_mst_item_exts: bl_fi_mst_item_ext_RowClass[] = [];
  bl_fi_mst_label_links: bl_fi_mst_label_link_RowClass[] = [];
  bl_fi_mst_label_hdrs: bl_fi_mst_label_hdr_RowClass[] = [];
}
